<nav #dock class="nav" [class.hidden]="scroll.dockHidden()">
  <ul class="nav-list">
    <li *ngFor="let item of navItems; let i = index" [class.active]="activeIndex === i" [class.disabled]="isLocked"
      (click)="navigateTo(item.route, i)" [attr.title]="item.tooltipKey | translate"
      [attr.aria-label]="item.tooltipKey | translate">
      <i [class]="item.icon">
      </i>
    </li>
  </ul>
</nav>
